import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getImage } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';

import { tradWithColors } from '@/utils/trad';

import Hero from '@/components/Hero';

const ConstructechHero = () => {
  const { t } = useTranslation();

  const htmlContent = useMemo(() => tradWithColors(t('heroTitle')), []);

  const data = useStaticQuery(graphql`
    query {
      dna: file(relativePath: { eq: "dna.png" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED)
        }
      }
    }
  `);

  return (
    <Hero
      fullHeight
      title={htmlContent}
      subTitle={<div>{t('heroSubtitle')}</div>}
      image={{
        image: getImage(data.dna),
        alt: 'dna icon',
      }}
    />
  );
};

export default ConstructechHero;
